import { getUserManager } from '@axa-fr/react-oidc-context';
import axios from 'axios';
import { User } from 'oidc-client';

const FaraGostarHttp = async () => {
  const um = (await getUserManager().getUser()) as User;
  const token = um.access_token;

  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const instance = axios.create({
    baseURL: window.config.apiUrl,
    headers,
  });

  return instance;
};

export default FaraGostarHttp;
